module.exports = __webpack_public_path__ + "4b806d1c90a1df79e9919f0402fd2571.png";